export default __webpack_public_path__ + "static/case-4-fddab0290f9bf1e3c36f0930a9aeb12a.png";